<template>
  <div style="margin-bottom: -16px">
    <div class="verticallyCenter mb16">
      <span class="fs14 mr16">行数</span>
      <div class="row-set">
        <div class="verticallyCenter el-input">
          <single-input
            class="mr8"
            style="width: 104px; flex: 1"
            :value.sync="rowLen"
            :noInputSuffixs="true"
            :min="minSize"
            :max="maxSize"
            :noInputHandle="true"
            @customBlur="onRowBlur"
            @keyup="onRowKeyUp"
            @changeValue="onRowBlur"
          />
          <div class="btn-wrapper">
            <span
              :class="rowLen === minSize ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
              @click="changeRow(0)"
            ></span>
            <span
              :class="rowLen === maxSize ? 'disabled num-btn icon-portal-plus' : 'num-btn icon-portal-plus'"
              @click="changeRow(1)"
            ></span>
          </div>
        </div>
      </div>
    </div>
    <div class="verticallyCenter">
      <span class="fs14 mr16">列数</span>
      <div class="row-set">
        <div class="verticallyCenter el-input">
          <single-input
            class="mr8"
            style="width: 104px; flex: 1"
            :value.sync="colLen"
            :noInputSuffixs="true"
            :min="minSize"
            :max="maxSize"
            :noInputHandle="true"
            @customBlur="onColBlur"
            @keyup="onColKeyUp"
            @changeValue="onColBlur"
          />
          <div class="btn-wrapper">
            <span
              :class="colLen === minSize ? 'disabled num-btn icon-portal-minus' : 'num-btn icon-portal-minus'"
              @click="changeCol(0)"
            ></span>
            <span
              :class="colLen === maxSize ? 'disabled num-btn icon-portal-plus' : 'num-btn icon-portal-plus'"
              @click="changeCol(1)"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "layout-setting",
  data() {
    return {
      rowLen: this.row,
      colLen: this.col,
      minSize: 1,
      maxSize: 50
    }
  },
  props: {
    row: {
      type: Number,
      default: 1
    },
    col: {
      type: Number,
      default: 1
    }
  },
  watch: {},
  computed: {
    ids() {
      return this.$store.state.states.activeID
    }
  },
  methods: {
    onRowKeyUp(e) {
      if (e.keyCode === 13) {
        e.target.blur()
        this.onRowBlur()
      }
    },
    onColKeyUp(e) {
      if (e.keyCode === 13) {
        e.target.blur()
        this.onColBlur()
      }
    },
    onRowBlur() {
      if (this.rowLen >= this.minSize && this.rowLen <= this.maxSize) {
        this.changeRowAndCol()
      }
    },
    onColBlur() {
      if (this.colLen >= this.minSize && this.colLen <= this.maxSize) {
        this.changeRowAndCol()
      }
    },
    // 修改列的值
    changeCol(flag) {
      if (flag === 1) {
        if (this.colLen < this.maxSize) {
          this.colLen++
          this.changeRowAndCol()
        }
      } else {
        if (this.colLen > this.minSize) {
          this.colLen--
          this.changeRowAndCol()
        }
      }
    },
    // 修改行的值
    changeRow(flag) {
      if (flag === 1) {
        if (this.rowLen < this.maxSize) {
          this.rowLen++
          this.changeRowAndCol()
        }
      } else {
        if (this.rowLen > this.minSize) {
          this.rowLen--
          this.changeRowAndCol()
        }
      }
    },
    changeRowAndCol() {
        this.$emit("changeRowAndCol", { row: this.rowLen, col: this.colLen })
    },
    // 记录状态
    addHistory() {
      const newData = this.getQuickShot()
      this.$addHistory({
        type: "update",
        stateType: "updateRect",
        payload: {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          path: this.ids.path,
          elementInAutoLayoutId: this.ids.elementInAutoLayoutId
        },
        before: this.before,
        data: newData
      })
      this.before = null
    }
  }
}
</script>

<style lang="scss" scoped>
.row-set {
  flex: 1;
  input {
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 0 10px;
    box-sizing: border-box;
    margin-right: 16px;
  }
  .btn-wrapper {
    background-color: var(--inputBg);
    border-radius: 4px;
    padding: 6px 0;
    font-size: 0;
    flex: 1;
    .num-btn {
      display: inline-block;
      width: 50%;
      text-align: center;
      line-height: 20px;
      font-size: 13px;
      cursor: pointer;
      &:not(:last-child) {
        border-right: 1px solid var(--sliderBackGround);
      }
      &:not(.disabled):hover {
        color: var(--themeColor);
      }
      &.disabled {
        color: var(--borderColorSeven);
        cursor: not-allowed;
      }
    }
  }
}
</style>
